export class ContentSecondaryNavigation {
  id: any;
  details: ContentSecondaryNavigationDetail;
  label: any;
  pagePath: any;

  constructor(id: any, contentjson?: any) {
    if (contentjson) {
      this.id = id;
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['details']) {
        this.details = new ContentSecondaryNavigationDetail(
          contentjson['details']
        ); //
      }
      if (contentjson['pagePath']) {
        this.pagePath = contentjson['pagePath'];
      }
    }
  }
}

export class ContentSecondaryNavigationDetail {
  mainNavigation: ContentSecondaryMainNavigation[];
  childpages: ContentSecondaryChildPage[];

  constructor(contentjson?: any) {
    if (contentjson) {
      this.mainNavigation = this.fillMainNavigation(
        contentjson['mainNavigation']
      );
      this.childpages = this.fillChildPages(contentjson['childPages']);
    } else {
      this.mainNavigation = [];
      this.childpages = [];
    }
  }

  private fillMainNavigation(
    contentjson?: any
  ): ContentSecondaryMainNavigation[] {
    let mainNav: ContentSecondaryMainNavigation[] = [];
    const mainNavs = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        mainNavs.set(
          counter,
          new ContentSecondaryMainNavigation(counter, value)
        );
        counter++;
      }
      mainNav = Array.from(mainNavs.values());
    }

    return mainNav;
  }

  private fillChildPages(contentjson: any): ContentSecondaryChildPage[] {
    const childpages: ContentSecondaryChildPage[] = [];
    if (contentjson) {
      let counter = 1;
      for (const page of contentjson) {
        childpages.push(new ContentSecondaryChildPage(counter, page));
        counter++;
      }
    }
    return childpages;
  }
}

export class ContentSecondaryMainNavigation {
  id: any;
  brandLabel: any;
  mobileImagePath: any;
  targetUrl: any;
  imagePathDesktop: any;
  openinnewTab: any;
  altText: any;
  externalimage: any;

  constructor(id: any, contentjson?: any) {
    if (contentjson) {
      this.id = id;
      if (contentjson['brandLabel']) {
        this.brandLabel = contentjson['brandLabel'];
      }
      if (contentjson['mobileImagePath']) {
        this.mobileImagePath = contentjson['mobileImagePath'];
      }
      if (contentjson['targetUrl']) {
        this.targetUrl = contentjson['targetUrl'];
      }
      if (contentjson['imagePathDesktop']) {
        this.imagePathDesktop = contentjson['imagePathDesktop'];
      }
      if (contentjson['openinnewTab']) {
        this.openinnewTab = contentjson['openinnewTab'];
      }
      if (contentjson['altText']) {
        this.altText = contentjson['altText'];
      }
      if (contentjson['externalimage']) {
        this.externalimage = contentjson['externalimage'];
      }
    }
  }
}

export class ContentSecondaryChildPage {
  id: any;
  pageName: any;
  pageUrl: any;
  openinnewTab: any;
  externalimage: any;

  constructor(id: any, contentjson?: any) {
    this.id = id;
    this.pageName = contentjson['pageName'];
    this.pageUrl = contentjson['pageUrl'];
    if (contentjson['openinnewTab']) {
      this.openinnewTab = contentjson['openinnewTab'];
    } else {
      this.openinnewTab = '';
    }
    if (contentjson['externalimage']) {
      this.externalimage = contentjson['externalimage'];
    } else {
      this.externalimage = '';
    }
  }
}
